import ReactGA from 'react-ga4';

const DEFAULT_MEASUREMENT_ID = 'G-7B41YC11PS';
const MEASUREMENT_ID =
  import.meta.env.VITE_GA_MEASUREMENT_ID?.trim() || DEFAULT_MEASUREMENT_ID;

let initialized = false;
let userIdWasSet = false;

interface InitializeOptions {
  enabled?: boolean;
  measurementId?: string;
}

type GoogleAnalyticsEventParameters = Record<string, string | number | boolean>;

export const initializeGoogleAnalytics = ({
  enabled = import.meta.env.PROD,
  measurementId = MEASUREMENT_ID,
}: InitializeOptions = {}): boolean => {
  if (!enabled || initialized) {
    return false;
  }

  if (!/^G-[A-Z0-9]+$/i.test(measurementId)) {
    console.warn('Google Analytics is disabled: invalid GA4 measurement ID.');
    return false;
  }

  // This is a single-page app, so page views are sent explicitly after every
  // route change rather than only for the first loaded document.
  ReactGA.initialize(measurementId, { gtagOptions: { send_page_view: false } });
  initialized = true;
  return true;
};

export const trackGoogleAnalyticsPageView = (path: string): void => {
  if (!initialized) {
    return;
  }

  ReactGA.send({ hitType: 'pageview', page: path });
};

export const trackGoogleAnalyticsEvent = (
  name: string,
  parameters: GoogleAnalyticsEventParameters = {},
): void => {
  if (!initialized) {
    return;
  }

  ReactGA.event(name, parameters);
};

export const updateGoogleAnalyticsUserId = (
  userId: number | undefined,
): void => {
  if (!initialized) {
    return;
  }

  if (userId !== undefined) {
    ReactGA.set({ userId: String(userId) });
    userIdWasSet = true;
  } else if (userIdWasSet) {
    ReactGA.set({ userId: null });
    userIdWasSet = false;
  }
};
